import React from 'react';
import { ShieldWarning, Trash } from '@phosphor-icons/react';

export const LegalPanelHeader = ({ panel, clearing, clearPanel }) => (
  <div className="flex items-start justify-between mb-4 flex-wrap gap-2">
    <div>
      <h3 className="font-outfit text-lg font-semibold text-[#09090B] flex items-center gap-2">
        <ShieldWarning size={20} className="text-[#002FA7]" /> Applicable Laws & Government Agencies
      </h3>
      <p className="text-xs text-[#6B7280] font-ibm mt-1">AI-curated, location- and incident-specific. Sources cited from official government domains only.</p>
    </div>
    {panel && (
      <button onClick={clearPanel} disabled={clearing} data-testid="legal-panel-clear-button"
        className="flex items-center gap-1.5 px-2.5 py-1.5 text-xs text-[#6B7280] hover:text-red-600 font-ibm border border-[#E5E7EB] rounded-md hover:border-red-200 transition-all disabled:opacity-50">
        <Trash size={12} /> Clear
      </button>
    )}
  </div>
);
